module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"button-1":"Plan upgrade","button-3":"Preferences","button-4":"Logout"},"pt-BR":{"button-1":"Upgrade de plano","button-3":"Preferências","button-4":"Sair da conta"}}')
  delete Component.options._Ctor
}
